import { CSSProperties } from 'react';

interface PropsType {
  style?: CSSProperties;
  color?: string;
}

const SvgIconLock = (props: PropsType) => {
  return (
    <svg
      width='80'
      height='80'
      viewBox='0 0 80 80'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
      style={props.style ? props.style : undefined}
    >
      <g mask='url(#mask0_1235_3833)'>
        <path
          d='M40 56.9446C39.0647 56.9446 38.2707 56.6182 37.6179 55.9654C36.9651 55.3126 36.6388 54.5186 36.6388 53.5833H43.3612C43.3612 54.5186 43.0349 55.3126 42.3821 55.9654C41.7293 56.6182 40.9353 56.9446 40 56.9446ZM33.2779 51.3058V48.5279H46.7221V51.3058H33.2779ZM33.5554 46.2779C31.6943 45.1021 30.2199 43.5975 29.1321 41.7642C28.044 39.9308 27.5 37.8892 27.5 35.6392C27.5 32.2225 28.7292 29.285 31.1875 26.8267C33.6458 24.3683 36.5833 23.1392 40 23.1392C43.4167 23.1392 46.3542 24.3683 48.8125 26.8267C51.2708 29.285 52.5 32.2225 52.5 35.6392C52.5 37.8892 51.9607 39.9308 50.8821 41.7642C49.8032 43.5975 48.324 45.1021 46.4446 46.2779H33.5554ZM34.5 43.5H45.5279C46.8335 42.6111 47.8589 41.4769 48.6042 40.0975C49.3494 38.7178 49.7221 37.2317 49.7221 35.6392C49.7221 32.9539 48.7731 30.6622 46.875 28.7642C44.9769 26.8658 42.6853 25.9167 40 25.9167C37.3147 25.9167 35.0231 26.8658 33.125 28.7642C31.2269 30.6622 30.2779 32.9539 30.2779 35.6392C30.2779 37.2317 30.6506 38.7178 31.3958 40.0975C32.1411 41.4769 33.1758 42.6111 34.5 43.5Z'
          fill={props.color ? props.color : '#E4E4E4'}
        />
      </g>
    </svg>
  );
};

export default SvgIconLock;
